// extracted by mini-css-extract-plugin
export default {"appContainer":"MockCasePage_appContainer__6NWTg"};